import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as thunks from 'features/thunks'
import PendingBranding from './pending-branding-model'
import {
  CreatePendingBrandingAsync,
  DeletePendingBrandingAsync,
  LoadPendingBrandingsAsync,
} from './pendingBranding-thunk'
const initialState: pendingBrandingSliceState = {
  pendingBranding: [],
  selected_pendingBranding: '',
  is_loading_pendingBranding: false,
  is_creating_pendingBranding: false,
  is_deleting_pendingBranding: false,
}
export interface pendingBrandingSliceState {
  pendingBranding: PendingBranding[]
  selected_pendingBranding?: string
  is_loading_pendingBranding: boolean
  is_creating_pendingBranding: boolean
  is_deleting_pendingBranding: boolean
}
export const pendingBrandingSlice = createSlice({
  name: 'pendingBranding',
  initialState,
  reducers: {
    setSelectedpendingBranding: (state, action) => {
      state.selected_pendingBranding = action.payload
    },
    clearStatependingBranding: (state) => {
      state.pendingBranding = []
      state.is_loading_pendingBranding = false
      state.is_creating_pendingBranding = false
      state.is_deleting_pendingBranding = false
    },
    mergependingBranding: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_pendingBranding = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.pendingBranding = merge(state.pendingBranding, payload) as any
        }
      }
    },

    add_pendingBranding: (state, action) => {
      if (action.payload) {
        state.pendingBranding = [...state.pendingBranding, action.payload]
      }
    },
    set_pendingBranding: (state, action) => {
      let { key, value, id } = action.payload
      state.pendingBranding = state.pendingBranding.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(thunks.PublishBrandingAsync.pending, (state) => {
      state.is_loading_pendingBranding = true
    })
    builder.addCase(thunks.PublishBrandingAsync.fulfilled, (state, action) => {
      state.is_loading_pendingBranding = false
      handleResult(action, state)
    })
    builder.addCase(thunks.PublishBrandingAsync.rejected, (state) => {
      state.is_loading_pendingBranding = false
    })

    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPendingBrandingsAsync.pending, (state) => {
      state.is_loading_pendingBranding = true
    })
    builder.addCase(LoadPendingBrandingsAsync.fulfilled, (state, action) => {
      state.is_loading_pendingBranding = false
      if (action.payload) {
        state.pendingBranding = action.payload
      }
    })
    builder.addCase(LoadPendingBrandingsAsync.rejected, (state) => {
      state.is_loading_pendingBranding = false
    })
    builder.addCase(CreatePendingBrandingAsync.pending, (state) => {
      state.is_creating_pendingBranding = true
    })
    builder.addCase(CreatePendingBrandingAsync.fulfilled, (state) => {
      state.is_creating_pendingBranding = false
    })
    builder.addCase(CreatePendingBrandingAsync.rejected, (state) => {
      state.is_creating_pendingBranding = false
    })
    builder.addCase(DeletePendingBrandingAsync.pending, (state) => {
      state.is_deleting_pendingBranding = true
    })
    builder.addCase(DeletePendingBrandingAsync.fulfilled, (state, action) => {
      state.is_deleting_pendingBranding = false
      if (state.pendingBranding) {
        state.pendingBranding = state.pendingBranding.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeletePendingBrandingAsync.rejected, (state) => {
      state.is_deleting_pendingBranding = false
    })
  },
})

function handleResult(action: any, state: pendingBrandingSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_pendingBranding = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.pendingBranding = merge(state.pendingBranding, payload) as any
    }
  }
}

export const {
  clearStatependingBranding,
  setSelectedpendingBranding,
  set_pendingBranding,
  mergependingBranding,
  add_pendingBranding,
} = pendingBrandingSlice.actions

export const get_pendingBranding =
  (id?: string) =>
  (state: {
    pendingBranding: {
      pendingBranding: PendingBranding[]
    }
  }): PendingBranding | null => {
    let temp = state?.pendingBranding?.pendingBranding?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.pendingBranding?.pendingBranding[0] || null
  }
export const get_selected_pendingBranding = (state: {
  pendingBranding: pendingBrandingSliceState
}): PendingBranding | null => {
  let id = state?.pendingBranding?.selected_pendingBranding
  let temp = state?.pendingBranding?.pendingBranding?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_pendingBranding = (state: {
  pendingBranding: {
    pendingBranding: PendingBranding[]
  }
}): PendingBranding[] => {
  let temp = state?.pendingBranding?.pendingBranding
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_pendingBranding_busy = (state: {
  pendingBranding: pendingBrandingSliceState
}) => {
  return (
    state?.pendingBranding.is_deleting_pendingBranding ||
    state?.pendingBranding.is_loading_pendingBranding ||
    state?.pendingBranding.is_creating_pendingBranding
  )
}
export const is_deleting_pendingBranding_busy = (state: {
  pendingBranding: pendingBrandingSliceState
}) => {
  return state?.pendingBranding.is_deleting_pendingBranding
}
export const is_loading_pendingBranding_busy = (state: {
  pendingBranding: pendingBrandingSliceState
}) => {
  return state?.pendingBranding.is_loading_pendingBranding
}
export const is_creating_pendingBranding_busy = (state: {
  pendingBranding: pendingBrandingSliceState
}) => {
  return state?.pendingBranding.is_creating_pendingBranding
}

export default pendingBrandingSlice.reducer
